import { EquityOrderCreateEntity, EquityQuoteEntity } from '@genial/services';
import { ResponsesEquityOrderCreateResponse } from '@genial/services/dist/models';
import { Utils } from '@genial/utils';

import { notificationChannelsData } from '../../../../../../../Resume/utils';
import { TicketApplicationBaseInfoProps } from '../../components/TicketApplicationSuccessDetails';

export type ResponsesEquityOrderCreateResponseWithOrderType = ResponsesEquityOrderCreateResponse & {
  orderType: 'Limit' | 'Market';
};

export const getEquitySuccessInfos = (
  offer: EquityQuoteEntity,
  order: EquityOrderCreateEntity,
  showSendingChannels: boolean,
  hideDateTimeFieldsOnProverOrigin: boolean,
  selectedOrderType?: 'Limit' | 'Market'
): TicketApplicationBaseInfoProps => {
  const orderHash = order.orderHash || order.orderId || '--';
  const orderName = order.orderName;

  const orderNameFormatted = orderName && orderHash ? `${orderName} - ${orderHash}` : '--';

  const orderChannels = notificationChannelsData({ order });

  const hasOrderOrigin = !!order?.interactionChannelAuditDetail as boolean;

  const orderType =
    ((order as { orderType?: 'Limit' | 'Market' })?.orderType ?? selectedOrderType ?? 'Limit') ===
    'Market'
      ? 'A mercado'
      : 'Limitada';

  const productDetails = [
    { label: 'Ativo', value: 'Renda Variável' },
    { label: 'Produto', value: `${offer.productName} | ${offer.symbol}` },
    { label: 'Operação', value: 'Compra' },
    { label: 'Validade da ordem', value: 'Hoje' },
    { label: 'Tipo da ordem', value: orderType },
    { label: 'Quantidade', value: String(order.orderQuantity) },
    { label: 'Valor por ativo', value: Utils.Mask.Money(order.orderPrice) },
    { label: 'Total estimado', value: Utils.Mask.Money(order.orderAmount) },
  ];

  const solicitationDate = order.interactionChannelAuditDetail?.interactionChannelDate;

  const channelDetails = [
    {
      label: 'Canal de solicitação',
      value: order.interactionChannelAuditDetail?.interactionChannelOption.channel || '--',
    },
  ];

  if (!hideDateTimeFieldsOnProverOrigin) {
    channelDetails.push(
      {
        label: 'Data de solicitação',
        value: solicitationDate ? Utils.Mask.DateFormat(solicitationDate, 'dd/MM/yyyy') : '',
      },
      {
        label: 'Horário de solicitação',
        value: solicitationDate ? Utils.Mask.DateFormat(solicitationDate, 'HH:mm') : '',
      }
    );
  }

  const orderDetails = [
    { label: 'Nome da ordem', value: orderNameFormatted },
    ...(hasOrderOrigin ? channelDetails : []),
  ];

  if (showSendingChannels) {
    orderDetails.push(
      { label: 'Canal de envio', value: orderChannels || '--' },
      {
        label: 'Hora/data de Envio',
        value: order.orderCreatedAt
          ? Utils.Mask.DateFormat(order.orderCreatedAt, 'dd/MM/yyyy HH:mm:ss')
          : '--',
      }
    );
  }

  return {
    orderHash,
    productDetails,
    orderDetails,
  };
};
